/**
 * Created by vladislav on 08.08.2022
 */

const WindowPersons = function (persons, parentNode, nodesToAvoid) {
    this.parentNode = parentNode;
    this.nodesToAvoid = nodesToAvoid;

    this.visible = true;
    let left, right;

    if (persons.left || persons.right) {
        left = persons.left;
        right = persons.right;
    } else {
        left = persons;
    }

    if (left) {
        this.leftPerson = this.createPerson(left);
    }

    if (right) {
        if (typeof right === "string") {
            right = {
                role: right
            };
        }
        right.orientation = "right";

        this.rightPerson = this.createPerson(right);
    }
};

WindowPersons.prototype.update = function () {
    const isVisible = this.positionPersons();

    this.toggleVisible(isVisible);
};

WindowPersons.prototype.positionPersons = function () {
    const styles = cleverapps.styles.WindowPersons;

    const nodes = this.nodesToAvoid.filter(Boolean);
    let widestNode = nodes[0];

    for (let i = 1; i < nodes.length; ++i) {
        const node = nodes[i];

        if (node.width * node.scale > widestNode.width * widestNode.scale) {
            widestNode = node;
        }
    }

    let isVisible = true;
    [this.leftPerson, this.rightPerson].filter(Boolean).forEach((person) => {
        person.stopAllActions();

        const orientation = person.getOrientation();
        person.setAlignment(styles.position[orientation]);

        if (widestNode) {
            const distanceBetweenObjects = Math.abs(person.x - widestNode.x);
            const sumWidth = (person.width + widestNode.width * widestNode.scale) / 2 + styles.offset;

            if (distanceBetweenObjects < sumWidth) {
                person.x = widestNode.x + sumWidth * (orientation === "left" ? -1 : 1);
            }
        }

        person.originalPosition = person.getPosition();

        isVisible = isVisible
            && person.x >= person.width * 0.2
            && person.x <= (cleverapps.resolution.getSceneSize().width - person.width * 0.2);
    }, this);

    return isVisible;
};

WindowPersons.prototype.createPerson = function (options) {
    options = Person.ParseOptions(options);
    const person = new Person({ ...options, forWindow: options.forWindow !== false });
    person.setVisible(this.visible);
    person.setAnchorPoint(0.5, 0);
    person.setLocalZOrder(3);
    this.parentNode.addChild(person);

    return person;
};

WindowPersons.prototype.getHidePosition = function (person) {
    let position;

    if (person.getOrientation() === "left") {
        position = cc.p(-person.width, person.y);
    } else {
        position = cc.p(cleverapps.Scenes.GetRunningScene().width + person.width, person.y);
    }
    return position;
};

WindowPersons.prototype.showPerson = function (person) {
    person.stopAllActions();
    person.setAlignment(this.getHidePosition(person));
    person.runAction(new cc.MoveTo(0.6, person.originalPosition).easing(cc.easeBackOut()));
};

WindowPersons.prototype.hidePerson = function (person) {
    person.stopAllActions();

    person.runAction(new cc.Sequence(
        new cc.MoveTo(0.6, this.getHidePosition(person)).easing(cc.easeBackIn()),
        new cc.RemoveSelf()
    ));
};

WindowPersons.prototype.showUp = function () {
    [this.leftPerson, this.rightPerson].forEach(function (person) {
        if (person) {
            this.showPerson(person);
        }
    }, this);
};

WindowPersons.prototype.hide = function () {
    [this.leftPerson, this.rightPerson].forEach(function (person) {
        if (person) {
            this.hidePerson(person);
        }
    }, this);
};

WindowPersons.prototype.toggleVisible = function (visible) {
    if (this.visible === visible) {
        return;
    }

    this.visible = visible;

    [this.leftPerson, this.rightPerson].forEach((person) => {
        if (person) {
            person.setVisible(visible);
            person.isShown = visible;
            cleverapps.scenes.onAvoidNodeVisibilityChanged();
        }
    });
};

WindowPersons.prototype.setLeftPerson = function (person) {
    person = Person.ParseOptions(person);

    if (this.leftPerson && this.leftPerson.getRole() === person.role) {
        return;
    }

    if (this.leftPerson) {
        this.hidePerson(this.leftPerson);
    }

    this.leftPerson = this.createPerson(person);

    this.positionPersons();

    this.showPerson(this.leftPerson);
};

WindowPersons.prototype.setRightPerson = function (person) {
    person = Person.ParseOptions(person);
    person.orientation = "right";

    if (this.rightPerson && this.rightPerson.getRole() === person.role) {
        return;
    }

    if (this.rightPerson) {
        this.hidePerson(this.rightPerson);
    }

    this.rightPerson = this.createPerson(person);
    this.showPerson(this.rightPerson);
};

cleverapps.styles.WindowPersons = {
    offset: 50,
    position: {
        "left": {
            x: { align: "left", dx: 50 },
            y: { align: "bottom", dy: -240 }
        },

        "right": {
            x: { align: "right", dx: -50 },
            y: { align: "bottom", dy: -240 }
        }
    }
};
